/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const StatusAlarm = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M64.263 126.307c6.942 0 12.607-5.666 12.607-12.607H51.656c0 6.941 5.667 12.607 12.607 12.607zm40.656-37.682V54.203c0-19.266-13.314-35.414-31.306-39.665v-4.249c0-5.242-4.25-9.35-9.35-9.35-5.099 0-9.349 4.25-9.349 9.35v4.249c-17.99 4.25-31.307 20.399-31.307 39.665v34.422L11 101.234v6.231h106.528v-6.231l-12.609-12.609z" />
  </svg>
);

export default extendIcon(StatusAlarm);
